/**
 * GA4/GTM dataLayer ecommerce events.
 * Ported from Flow layout/theme.liquid (initGa4SelectItem, initGa4CartAddInterceptor,
 * initCartButtonHandler view_cart). Pinterest events come from the Pinterest app's web pixel.
 *
 * Horizon has no WeTheme trackAddToCart / toggleRightDrawer, so this listens to the
 * theme's own events instead of patching fetch:
 * - `cart:update` (CartAddEvent from product-form-component, or the theme.liquid quick add)
 * - `dialog:open` on <cart-drawer-component> (non-bubbling, so captured on document)
 */
(function () {
  'use strict';
  if (window.__clnfTrackingBound) return;
  window.__clnfTrackingBound = true;

  function pushDataLayer(payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {}
  }

  function toGa4Item(line, index) {
    return {
      item_id: String(line.variant_id || line.id),
      item_name: line.product_title || line.title || '',
      item_variant: line.variant_title || '',
      item_brand: line.vendor || '',
      item_category: line.product_type || '',
      price: (line.final_price != null ? line.final_price : line.price || 0) / 100,
      quantity: line.quantity || 1,
      index: index,
    };
  }

  function trackAddToCart(lines, currency, cartSource) {
    if (!lines.length) return;
    var value = 0;
    var items = lines.map(function (line, i) {
      var item = toGa4Item(line, i);
      value += item.price * item.quantity;
      return item;
    });
    var payload = {
      event: 'add_to_cart',
      ecommerce: { currency: currency, value: value.toFixed(2), items: items },
    };
    if (cartSource) payload.cart_source = cartSource;
    pushDataLayer(payload);
  }

  function onCartUpdate(event) {
    var detail = event.detail || {};
    var data = detail.data || {};
    if (data.didError) return;
    var cart = detail.resource || {};
    var currency = cart.currency || 'USD';

    if (data.source === 'product-form-component') {
      // Single adds use the variant id as sourceId; batch adds use the component id.
      var variantId = String(detail.sourceId || '');
      if (!/^\d+$/.test(variantId)) return;
      var line = null;
      (cart.items || []).some(function (item) {
        if (String(item.variant_id) === variantId) {
          line = item;
          return true;
        }
        return false;
      });
      var added = Object.assign({ variant_id: variantId }, line || {}, {
        quantity: Number(data.itemCount) || 1,
      });
      trackAddToCart([added], currency);
    } else if (data.source === 'clnf-quick-add' && Array.isArray(data.addedItems)) {
      trackAddToCart(data.addedItems, currency);
    } else if (data.source === 'clnf-standard-actions' && Array.isArray(data.addedItems)) {
      // Agent (WebMCP) or app adds through Shopify.actions.updateCart (snippets/clnf-standard-actions.liquid).
      trackAddToCart(data.addedItems, currency, 'standard_action');
    }
  }

  function onDialogOpen(event) {
    var target = event.target;
    if (!target || target.localName !== 'cart-drawer-component') return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        pushDataLayer({
          event: 'view_cart',
          ecommerce: {
            currency: cart.currency || 'USD',
            value: ((cart.total_price || 0) / 100).toFixed(2),
            items: (cart.items || []).map(toGa4Item),
          },
        });
      })
      .catch(function () {});
  }

  function onCardClick(event) {
    var link = event.target.closest('.grid-view-item a[href*="/products/"]');
    if (!link) return;
    var card = link.closest('.grid-view-item');
    if (!card || !card.dataset.gaItemId) return;
    pushDataLayer({
      event: 'select_item',
      ecommerce: {
        item_list_id: card.dataset.gaListId || '',
        item_list_name: card.dataset.gaListName || '',
        items: [
          {
            item_id: card.dataset.gaItemId,
            item_name: card.dataset.gaItemName || '',
            item_variant: card.dataset.gaItemVariant || '',
            item_brand: card.dataset.gaItemBrand || '',
            item_category: card.dataset.gaItemCategory || '',
            price: parseFloat(card.dataset.gaPrice) || 0,
            quantity: 1,
            index: 0,
          },
        ],
      },
    });
  }

  document.addEventListener('cart:update', onCartUpdate);
  document.addEventListener('dialog:open', onDialogOpen, true);
  document.addEventListener('click', onCardClick, { passive: true });
})();
